import { SERVICE_ADD_ACTION_TYPE, SERVICE_DELETE_ACTION_TYPE, SERVICE_DETAIL_ACTION_TYPE, SERVICE_LIST_ACTION_TYPE } from "../../utils/constants";

const initialState = [];
function additionalServiceReducer(state=initialState,action){
    const{type,payload}=action;

    switch(type){
        case SERVICE_LIST_ACTION_TYPE:
            return [...state,payload];
        case SERVICE_ADD_ACTION_TYPE:
            return [...state,payload];
        case SERVICE_DETAIL_ACTION_TYPE:
            return [...state,payload];
        case SERVICE_DELETE_ACTION_TYPE:
            return [...state,payload];   
        default:
            return state;
    }
}
export default additionalServiceReducer;